/* eslint-disable radix */
import { handleResponse, handleError } from "./apiUtils.js";
import { generateClient } from 'aws-amplify/api';
import * as queries from '../graphql/queries.js';
import * as mutations from '../graphql/mutations.js';
import { client } from "webpack-dev-server/bin/cli-flags.js";

const gClient = generateClient();

export async function getCreateTourPreReq(dayTypeId, resourceId, date, userId) {

  let createTourPreReq = await gClient.graphql(
    {
      query: queries.tourApIgetCreateTourPreReq,
      variables: {
        dayTypeId,
        resourceId: parseInt(resourceId),
        date,
        userId: parseInt(userId)
      }
    }
  )

  return createTourPreReq.data.tourAPIgetCreateTourPreReq;
}


export async function createTour(parameters) {

  parameters.IPAddress = '27.0.0.1';

  let response = await gClient.graphql(
    {
      query: mutations.tourApIcreateTour, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.tourAPIcreateTour;
}

export async function deleteTour(tourId, userId) {

  const IPAddress = '27.0.0.1';

  let response = await gClient.graphql(
    {
      query: mutations.tourApIdeleteTour, 
      variables: {tourId, userId, IPAddress}
    }
  )
    .catch(handleError);

  return response.data.tourAPIdeleteTour;
}

export async function updateTour(parameters) {

  parameters.IPAddress = '27.0.0.1';
  // console.log('***** UPDATE TOUR PARAMETERS ******');
  // console.log(parameters); // debug

  let response = await gClient.graphql(
    {
      query: mutations.tourApIupdateTour, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.tourAPIupdateTour;
}

export async function getActiveTours(resourceId, startTime, timeZoneId) {

  let response = await gClient.graphql(
    {
      query: queries.tourApIgetActiveTours,
      variables: {
        resourceId,
        startTime,
        timeZoneId
      }
    }
  )
    .catch(handleError);

  return response.data.tourAPIgetActiveTours;
}

export async function getDefaultTourLength(relatedServiceId, startTime, resourceId, serviceId) {

  let response = await gClient.graphql(
    {
      query: queries.tourApIgetDefaultTourLength,
      variables: {
        relatedServiceId,
        startTime,
        resourceId,
        serviceId
      }
    }
  )
    .catch(handleError);

  return response.data.tourAPIgetDefaultTourLength;
}

export async function getTour(parameters) {

  let response = await gClient.graphql(
    {
      query: queries.tourApIgetTour, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.tourAPIgetTour;
}

export async function createTourActivityFlag(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await gClient.graphql(
    {
      query: mutations.tourApIcreateTourActivityFlag, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.tourAPIcreateTourActivityFlag;
}

export async function createTourIndicator(parameters) {

  let response = await gClient.graphql(
    {
      query: mutations.tourApIcreateTourIndicator, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.tourAPIcreateTourIndicator;
}

export async function createTourPayTransaction(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await gClient.graphql(
    {
      query: mutations.tourApIcreateTourPayTransaction, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.tourAPIcreateTourPayTransaction;
}

export async function deleteTourActivityFlag(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await gClient.graphql(
    {
      query: mutations.tourApIdeleteTourActivityFlag, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.tourAPIdeleteTourActivityFlag;
}

export async function deleteTourIndicator(tourIndicatorId) {

  let response = await gClient.graphql(
    {
      query: mutations.tourApIdeleteTourIndicator, 
      variables: { tourIndicatorId }
    }
  )
    .catch(handleError);

  return response.data.tourAPIdeleteTourIndicator;
}

export async function deleteTourPayTransaction(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await gClient.graphql(
    {
      query: mutations.tourApIdeleteTourPayTransaction, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.tourAPIdeleteTourPayTransaction;
}

export async function getActivityFlagByTour(tourId) {

  let response = await gClient.graphql(
    {
      query: queries.tourApIgetActivityFlagByTour, 
      variables: { tourId }
    }
  )
    .catch(handleError);

  return response.data.tourAPIgetActivityFlagByTour;
}

export async function getTourActivityFlags(tourId) {

  let response = await gClient.graphql(
    {
      query: queries.tourApIgetTourActivityFlags, 
      variables: { tourId }
    }
  )
    .catch(handleError);

  return response.data.tourAPIgetTourActivityFlags;
}

export async function getCodesByIndicator(indicatorId) {

  let response = await gClient.graphql(
    {
      query: queries.tourApIgetCodesByIndicator, 
      variables: { indicatorId }
    }
  )
    .catch(handleError);
  return response.data.tourAPIgetCodesByIndicator;
}

export async function getIndicatorsById(indicatorId) {

  let response = await gClient.graphql(
    {
      query: queries.tourApIgetIndicatorsById, 
      variables: { indicatorId }
    }
  )
    .catch(handleError);

  return response.data.tourAPIgetIndicatorsById;
}

export async function getIndicatorsByTour(tourId) {

  let response = await gClient.graphql(
    {
      query: queries.tourApIgetIndicatorsByTour, 
      variables: { tourId }
    }
  )
    .catch(handleError);

  return response.data.tourAPIgetIndicatorsByTour;
}

export async function getJobElementsByTour(tourId) {

  let response = await gClient.graphql(
    {
      query: queries.tourApIgetJobElementsByTour, 
      variables: { tourId }
    }
  )
    .catch(handleError);

  return response.data.tourAPIgetJobElementsByTour;
}

export async function getTourMeals(tourId) {

  let response = await gClient.graphql(
    {
      query: queries.tourApIgetTourMeals, 
      variables: { tourId }
    }
  )
    .catch(handleError);

  return response.data.tourAPIgetTourMeals;
}

export async function getPayTransactionsByTour(tourId) {

  let response = await gClient.graphql(
    {
      query: queries.tourApIgetPayTransactionsByTour, 
      variables: { tourId }
    }
  )
    .catch(handleError);

  return response.data.tourAPIgetPayTransactionsByTour;
}

export async function getTourActivityFlag(tourActivityFlagId) {

  let response = await gClient.graphql(
    {
      query: queries.tourApIgetTourActivityFlag, 
      variables: { tourActivityFlagId }
    }
  )
    .catch(handleError);

  return response.data.tourAPIgetTourActivityFlag;
}

export async function getTourIndicator(tourIndicatorId) {

  let response = await gClient.graphql(
    {
      query: queries.tourApIgetTourIndicator, 
      variables: { tourIndicatorId }
    }
  )
    .catch(handleError);

  return response.data.tourAPIgetTourIndicator;
}

export async function getTourIndicators(tourId) {

  let response = await gClient.graphql(
    {
      query: queries.tourApIgetTourIndicators, 
      variables: { tourId }
    }
  )
    .catch(handleError);

  return response.data.tourAPIgetTourIndicators;
}

export async function getTourPayTransactions(tourId) {

  let response = await gClient.graphql(
    {
      query: queries.tourApIgetTourPayTransactions, 
      variables: { tourId }
    }
  )
    .catch(handleError);

  return response.data.tourAPIgetTourPayTransactions;
}

export async function getTourPayTransaction(tourPayTransactionId) {

  let response = await gClient.graphql(
    {
      query: queries.tourApIgetTourPayTransaction, 
      variables: { tourPayTransactionId }
    }
  )
    .catch(handleError);

  return response.data.tourAPIgetTourPayTransaction;
}

export async function updateTourActivityFlag(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await gClient.graphql(
    {
      query: mutations.tourApIupdateTourActivityFlag, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.tourAPIupdateTourActivityFlag;
}

export async function updateTourIndicator(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await gClient.graphql(
    {
      query: mutations.tourApIupdateTourIndicator, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.tourAPIupdateTourIndicator;
}

export async function updateTourPayTransaction(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await gClient.graphql(
    {
      query: mutations.tourApIupdateTourPayTransaction, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.tourAPIupdateTourPayTransaction;
}

export async function getTourExists(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await gClient.graphql(
    {
      query: queries.tourApIgetTourExists, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.tourAPIgetTourExists;
}

export async function getIfToursAreInDateRange(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await gClient.graphql(
    {
      query: queries.tourApIgetIfToursAreInDateRange, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.tourAPIgetIfToursAreInDateRange;
}
